(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initJourney = root => {
    root.querySelectorAll('[data-t977-process]').forEach(process => {
      const journey = process.querySelector('[data-t977-journey]');
      if (!journey || journey.dataset.t977Ready) return;
      journey.dataset.t977Ready = 'true';
      const steps = [...journey.querySelectorAll('[data-t977-step]')];
      if (!steps.length) return;

      if (process.classList.contains('t977-process--carousel')) {
        const previous = process.querySelector('[data-t977-previous]');
        const next = process.querySelector('[data-t977-next]');
        const current = process.querySelector('[data-t977-current]');
        let activeIndex = 0;

        const update = index => {
          activeIndex = Math.max(0, Math.min(index, steps.length - 1));
          if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
          if (previous) previous.disabled = activeIndex === 0;
          if (next) next.disabled = activeIndex === steps.length - 1;
        };

        const goTo = index => {
          const targetIndex = Math.max(0, Math.min(index, steps.length - 1));
          const targetLeft = targetIndex === steps.length - 1
            ? journey.scrollWidth - journey.clientWidth
            : steps[targetIndex].offsetLeft - journey.offsetLeft;
          journey.scrollTo({
            left: targetLeft,
            behavior: reducedMotion.matches ? 'auto' : 'smooth'
          });
          update(targetIndex);
        };

        previous?.addEventListener('click', () => goTo(activeIndex - 1));
        next?.addEventListener('click', () => goTo(activeIndex + 1));

        let scrollFrame;
        journey.addEventListener('scroll', () => {
          window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(() => {
            const left = journey.scrollLeft;
            const maxScroll = journey.scrollWidth - journey.clientWidth;
            if (Math.abs(maxScroll - left) <= 2) {
              update(steps.length - 1);
              return;
            }
            const closest = steps.reduce((best, step, index) => {
              const distance = Math.abs((step.offsetLeft - journey.offsetLeft) - left);
              return distance < best.distance ? { index, distance } : best;
            }, { index: 0, distance: Number.POSITIVE_INFINITY });
            update(closest.index);
          });
        }, { passive: true });

        update(0);
        return;
      }

      if (reducedMotion.matches || !('IntersectionObserver' in window)) {
        steps.forEach(step => step.classList.add('is-visible'));
        return;
      }

      journey.classList.add('t977-is-enhanced');
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
      steps.forEach(step => observer.observe(step));
    });
  };

  const boot = root => initJourney(root || document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
